import React from 'react';
import { Translate } from 'react-jhipster';

import { NavItem, NavLink, NavbarBrand } from 'reactstrap';
import { NavLink as Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import appConfig from 'app/config/constants';

export const BrandIcon = props => (
  <div {...props} className="brand-icon">
    {/* <img src="content/images/logo.png" alt="Logo" /> */}
    <img src={require('app/images/header/quoc_huy.svg')} alt="Logo" />
  </div>
);

export const Brand = props => (
  <NavbarBrand tag={Link} to="/admin" className="brand-logo">
    <Row>
      <Col>
        <BrandIcon />
      </Col>
      <Col>
        <Row>
          <label className="brand-title">Cổng Dịch vụ công quốc gia</label>
        </Row>
        <Row>
          <label className="brand-sub-title">Người dân, doanh nghiệp là trung tâm phục vụ</label>
        </Row>
      </Col>
    </Row>
    {/* <BrandIcon /> */}
    {/* <img src={require('app/images/header/logo-admin.svg')} alt="" /> */}

    {/* <span className="navbar-version">{appConfig.VERSION}</span> */}
  </NavbarBrand>
);

export const Home = props => (
  <NavItem>
    <NavLink tag={Link} to="/admin" className="d-flex align-items-center">
      <FontAwesomeIcon icon="home" />
      <span>
        <Translate contentKey="global.menu.home">Home</Translate>
      </span>
    </NavLink>
  </NavItem>
);
